// Available fields for the Customer Request report config
// (ids must match the columns the Request List export already renders).
const custReqReptFieldsArr = [
    { id: "custReqId", label: "Request Id", minWidth: 100 },
    { id: "name", label: "Customer", minWidth: 100 },
    { id: "location", label: "From - To", minWidth: 190 },
    { id: "load", label: "Material & Weight", minWidth: 100 },
    { id: "loadType", label: "Load Type", minWidth: 80 },
    { id: "preTruckTypes", label: "Truck Types", minWidth: 190 },
    { id: "shipCreated", label: "Shipment Created", minWidth: 50 },
    { id: "c_at", label: "Posted On", minWidth: 100 },
];

export default custReqReptFieldsArr;
